export default __webpack_public_path__ + "static/media/shrink_it_logo.5788105e.jpg";